var _g, _g2, _g3, _g4;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgSlack = function SvgSlack(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 122.8 122.8",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1",
    fill: "#e01e5a"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1",
    d: "M25.8 77.6a12.9 12.9 0 11-12.9-12.9h12.9z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2",
    d: "M32.3 77.6a12.9 12.9 0 0125.8 0v32.3a12.9 12.9 0 01-25.8 0V77.6z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2",
    fill: "#36c5f0"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3",
    d: "M45.2 25.8a12.9 12.9 0 1112.9-12.9v12.9z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 4",
    d: "M45.2 32.3a12.9 12.9 0 110 25.8H12.9a12.9 12.9 0 010-25.8h32.3z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 3",
    fill: "#2eb67d"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 5",
    d: "M97 45.2a12.9 12.9 0 1112.9 12.9H97z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 6",
    d: "M90.5 45.2a12.9 12.9 0 11-25.8 0V12.9a12.9 12.9 0 1125.8 0z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4",
    fill: "#ecb22e"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 7",
    d: "M77.6 97a12.9 12.9 0 11-12.9 12.9V97z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 8",
    d: "M77.6 90.5a12.9 12.9 0 010-25.8h32.3a12.9 12.9 0 110 25.8z"
  }))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSlack, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/slack.29cb8946.svg";
export { ForwardRef as ReactComponent };